// ============================================================================
// services/reminderModule/reminderServices.js
// ============================================================================
// Matches the existing service pattern (see ptpResponseServices.js):
//   - URL constants from apiConfig.js
//   - apiClient (axios instance, handles base URL + auth)
//   - try/catch, log the error, return response.data
// Error strings are inlined here (no separate reminderConstants.js needed —
// the page defines its own UI constants).
// ============================================================================

import { REMINDER_URLS } from "../apiConfig.js";
import apiClient from "../apiInstance.js";

// List all reminders (each includes its dpdBuckets array).
export const fetchReminders = async () => {
  try {
    const response = await apiClient.get(REMINDER_URLS.FETCH_REMINDERS);
    return response.data;
  } catch (error) {
    console.error("Error fetching reminders", error);
    throw error;
  }
};

// Get one reminder by id.
export const fetchReminderById = async (id) => {
  try {
    const response = await apiClient.get(`${REMINDER_URLS.FETCH_REMINDER}/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching reminder", error);
    throw error;
  }
};

// Create a reminder. payload shape:
// {
//   name, channel ('texts'|'emails'), message,
//   triggerType ('lapse'|'specific'),
//   lapseAmount, lapseUnit ('hours'|'days'),   // when triggerType='lapse'
//   specificAt, timezone,                      // when triggerType='specific'
//   campaignId (int|null),
//   dpdBuckets: string[],                      // [] == Any
//   isEnabled (bool), validFrom, validTo, createdBy
// }
export const createReminder = async (payload) => {
  try {
    const response = await apiClient.post(REMINDER_URLS.CREATE_REMINDER, payload);
    return response.data;
  } catch (error) {
    console.error("Error creating reminder", error);
    throw error;
  }
};

// Update a reminder by id (same payload shape as create).
export const updateReminder = async (id, payload) => {
  try {
    const response = await apiClient.put(`${REMINDER_URLS.UPDATE_REMINDER}/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error("Error updating reminder", error);
    throw error;
  }
};

// Toggle enabled/disabled.
export const toggleReminderEnabled = async (id, isEnabled) => {
  try {
    const response = await apiClient.patch(
      `${REMINDER_URLS.TOGGLE_REMINDER}/${id}/enabled`,
      { isEnabled }
    );
    return response.data;
  } catch (error) {
    console.error("Error toggling reminder", error);
    throw error;
  }
};

// Delete a reminder by id.
export const deleteReminder = async (id) => {
  try {
    const response = await apiClient.delete(`${REMINDER_URLS.DELETE_REMINDER}/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting reminder", error);
    throw error;
  }
};

export const fetchCampaignMessageTimes = async (campaignId, channel) => {
    try {
      const response = await apiClient.get(REMINDER_URLS.CAMPAIGN_TIMES, {
        params: { campaignId, channel },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching campaign message times", error);
      throw error;
    }
  };